import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getQuestionsAndAnswers } from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { defaultAnswerState, questionPresentationContent } from "../../../data/QuestionPresentation";
import { useSourceSystem } from "../../../hooks/useSourceSystem";

function useModificationQuestionCompact({ question }: { question: Question }) {
  const dispatch = useDispatch();
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const {
    sourceSystem: { analyticSearchParam }
  } = useSourceSystem();

  const noDamageAnswer = question.answers[1];
  const noDamageAnswerID = noDamageAnswer.id;
  const damageAnswer = question.answers[0].id;

  const {
    groupName,
    labelForSelect,
    component: { content }
  } = questionPresentationContent[question.id];

  let showSelectLabel;
  let showSelectValue;

  if ("showSelectLabel" in content!) {
    ({ showSelectLabel, showSelectValue } =
      content);
  }

  const [answer, setAnswer] = useState(defaultAnswerState);

  useEffect(() => {
    setAnswer(storedAnswer ? storedAnswer : "");
  }, [question.selectedAnswer, questionsAndAnswers, question.id, storedAnswer]);

  const handleAnswerChange = (answerId: number) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.updateConditionalAnswersSubmitted(question.id)
    );
    setAnswer([answerId]);
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({ [question.id]: [answerId] })
    );
  };

  return {
    damageAnswer: damageAnswer,
    noDamage: noDamageAnswerID,
    handleChange: handleAnswerChange,
    answer,
    labelForSelect: labelForSelect || "",
    groupName: groupName || "",
    questionString: question.content,
    noDamageLabel: noDamageAnswer.label,
    showSelectLabel,
    showSelectValue,
  };
}

export default useModificationQuestionCompact;
